import { render, staticRenderFns } from "./MidiInputs.vue?vue&type=template&id=0935a035&scoped=true&"
import script from "./MidiInputs.vue?vue&type=script&lang=js&"
export * from "./MidiInputs.vue?vue&type=script&lang=js&"
import style0 from "./MidiInputs.vue?vue&type=style&index=0&id=0935a035&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0935a035",
  null
  
)

export default component.exports